import { render } from "./TabMenu.vue?vue&type=template&id=10d4d2de&scoped=true"
import script from "./TabMenu.vue?vue&type=script&lang=js"
export * from "./TabMenu.vue?vue&type=script&lang=js"

import "./TabMenu.vue?vue&type=style&index=0&id=10d4d2de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d4d2de"]])

export default __exports__